import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import { SignOut } from "phosphor-react";
import useKeyPress from "../../../services/hooks/useKeyPress";
import HeaderMenuItems from "../../Header/HeaderMenuItems";
import "./Sitemap.css";
import useDisableScroll from "../../../hooks/useDisableScroll";

const Sitemap = (props) => {
  const enter = useKeyPress("Enter");
  const { show, close, setObjectivesFilters, isLineManager, isDirtyForm, renderDirtyNavModal } =
    props;

  const openLogoutpModal = () => {
    close();
    document.getElementById("toolbarLogout").click();
  };
  useDisableScroll(show);

  return (
    <Modal
      type="alert"
      title="Sitemap"
      id="Sitemap"
      cancelText="Close"
      cancelButtonColor="blue"
      show={show}
      onClose={close}
      style={{ maxWidth: "90%", width: "625px", position: "fixed" }}
    >
      <Text wrapper="h1" type="header" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
        Sitemap
      </Text>
      <HeaderMenuItems
        click={close}
        showIcons
        isLineManager={isLineManager}
        setObjectivesFilters={setObjectivesFilters}
        isDirtyForm={isDirtyForm}
        renderDirtyNavModal={renderDirtyNavModal}
      >
        <li
          tabIndex={0}
          role="menuitem"
          onClick={openLogoutpModal}
          onKeyDown={enter && openLogoutpModal}
          id="toolbarLogout"
        >
          <div className="icon-wrapper">
            <SignOut color="rgba(55,81,157, 1)" size={32} />
          </div>
          Logout
        </li>
      </HeaderMenuItems>
    </Modal>
  );
};

export default Sitemap;
